/**
 * Read-only "Data access" row for a credential record's `ahoy_permissions`.
 *
 * Registered as `customPropertyReadRenderers.ahoy_permissions` for
 * `ahoy_service_account`, so the overview shows one line
 * per data type ("Contacts — All records · Can write") instead of the generic
 * badge cloud. The rendering itself is the canonical `PermissionsValueLabel`
 * in its `rows` layout — this component only owns the overview row chrome.
 */

import { PermissionsValueLabel } from '@/lib/crm/components/properties/labels/PermissionsValueLabel';

export function CredentialAccessRows({
  value,
  orgId,
}: {
  value: unknown;
  orgId: number;
}) {
  return (
    <div className='flex flex-col gap-1.5'>
      <span className='text-body-small font-medium text-[var(--color-text-secondary)]'>
        Data access
      </span>
      <PermissionsValueLabel value={value} orgId={orgId} layout='rows' />
    </div>
  );
}
